import '.a7{position:relative;}.ssr-plugin'
import '.f{width:100%;}.ssr-plugin'
import '.gh{height:36px;}.ssr-plugin'
import '.a1{gap:4px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.bp{justify-content:start;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import '.i{background:transparent;}.ssr-plugin'
import '.eq{outline:none;}.ssr-plugin'
import '.ck{flex-grow:1;}.ssr-plugin'
import '.bc{overflow:hidden;}.ssr-plugin'
import '.iq{text-overflow:ellipsis;}.ssr-plugin'
import '.h2{white-space:nowrap;}.ssr-plugin'
import '.ir{text-align:left;}.ssr-plugin'
import '.cw{margin-left:auto;}.ssr-plugin'
import '.ek{flex-shrink:0;}.ssr-plugin'
import '.is{transition:transform 0.2s cubic-bezier(0.34, 1.56, 0.64, 1);}.ssr-plugin'
import { forwardRef, MouseEvent, ReactNode, useEffect, useState } from 'react'
import { Icon, IconProps } from '../Icon/index.js'
import { styled, Style } from 'inlines'
import { radius } from '../../utils/radius.js'
import { colors } from '../../tokens/colors.js'
import { Text } from '../Text/index.js'

type DropdownProps = {
  disabled?: boolean
  placeholder?: string
  prefix?: ReactNode | string
  error: boolean
  leadIcon?: IconProps['variant']
  value?: ReactNode
  open?: boolean
  onClick?: (event: MouseEvent) => void
  ghost?: boolean
  style?: Style
}

const Dropdown = forwardRef<HTMLButtonElement, DropdownProps>(
  (
    {
      disabled,
      error,
      placeholder,
      value,
      leadIcon,
      prefix,
      open,
      onClick,
      ghost,
      style,
    },
    ref,
  ) => {
    return (
      <styled.button className="a7 f gh a1 a bp d i eq"
        onClick={onClick}
        ref={ref}
        disabled={disabled}
        data-open={open ? open : undefined}
        data-error={error ? error : undefined}
        style={{
          padding: leadIcon || value ? '0 6px' : '0 10px',
          borderRadius: radius[12],
          border: ghost
            ? '1px solid transparent'
            : `1px solid ${colors.neutral20Adjusted}`,
          color: !value ? colors.neutral60 : colors.neutral100,
          '&:not(:disabled):focus-visible, &[data-open]': {
            background: colors.neutralInverted100,
            border: `1px solid ${colors.neutral100}`,
            outline: `4px solid ${colors.neutral20}`,
          },
          '&[data-error]': {
            border: `1px solid ${colors.red80}`,
          },
          '&[data-error]:not(:disabled):focus-visible, &[data-error][data-open]':
            {
              background: colors.neutralInverted100,
              border: `1px solid ${colors.red100}`,
              outline: `4px solid ${colors.red60}`,
            },
          '&:disabled': {
            color: colors.neutral20,
            background: colors.neutral5,
            border: `1px solid transparent`,
          },
          ...style,
        }}
      >
        {leadIcon && (
          <Icon
            variant={leadIcon}
            color={disabled ? 'neutral20' : 'neutral60'}
          />
        )}
        {!leadIcon && prefix && typeof prefix === 'string' ? (
          <span
            style={{
              marginRight: -4,
              pointerEvents: typeof prefix === 'string' ? 'none' : 'auto',
            }}
          >
            <Text color="inherit">{prefix}</Text>
          </span>
        ) : (
          prefix
        )}
        <div className="ck bc iq h2 ir"
        >
          {!value ? (
            <Text
              color={disabled ? 'neutral20' : 'neutral60'}
              variant="display-regular"
              selectableText={false}
            >
              {placeholder}
            </Text>
          ) : typeof value === 'string' ? (
            <Text color="inherit" selectableText={false}>
              {value}
            </Text>
          ) : (
            value
          )}
        </div>
        <div className="cw a ek is"
          style={{
            color: open ? colors.neutral100 : colors.neutral60,
            transform: open ? 'rotate(180deg)' : 'rotate(0deg)',}}
        >
          <Icon
            variant={ghost ? 'tiny-chevron-down' : 'chevron-down'}
            color={disabled ? 'neutral20' : 'neutral60'}
          />
        </div>
      </styled.button>
    )
  },
)
export { Dropdown }
export type { DropdownProps }
